/*
 * XBoat custom product section behavior.
 * Used by main-product-v2 (configured by BEM prefix): thumbnail gallery,
 * quantity selector with team-quantity gate modal, and the button-based
 * variant picker (cascade + availability + price/URL sync).
 *
 * Behavior is identical across sections; callers differ only by config:
 *   XBProductCustom.init({
 *     rootId, modalId, prefix, priceWrapperClass,
 *     variants, addToCartText, soldOutText, unavailableText
 *   });
 */
window.XBProductCustom = (function () {
  function init(config) {
    var section = document.getElementById(config.rootId);
    if (!section) return;

    var prefix = config.prefix;
    var P = '.' + prefix;
    var productData = config.variants || [];
    var addToCartText = config.addToCartText || 'Add to Cart';
    var soldOutText = config.soldOutText || 'Sold out';
    var unavailableText = config.unavailableText || 'Unavailable';
    var priceWrapperClass = config.priceWrapperClass || (prefix + '__price-wrapper');

    // Thumbnail gallery
    var mainImage = section.querySelector(P + '__main-image');
    var thumbs = section.querySelectorAll(P + '__media-thumb');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (mainImage) {
          var newSrc = this.dataset.mediaSrc;
          // Clear srcset so src takes effect (Shopify generates srcset by default)
          mainImage.removeAttribute('srcset');
          mainImage.src = newSrc;
        }
      });
    });

    // Quantity selector
    var quantityInput = section.querySelector(P + '__quantity-input');
    var quantityBtns = section.querySelectorAll(P + '__quantity-btn');
    var teamThreshold = parseInt((quantityInput && quantityInput.dataset.teamThreshold) || '8');
    var modal = document.getElementById(config.modalId);
    var teamModalShown = false;

    quantityBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = this.dataset.action;
        var value = parseInt(quantityInput.value) || 1;

        if (action === 'increase') {
          value++;
        } else if (action === 'decrease' && value > 1) {
          value--;
        }

        quantityInput.value = value;
        checkTeamThreshold(value);
      });
    });

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        checkTeamThreshold(parseInt(this.value) || 1);
      });
    }

    function checkTeamThreshold(quantity) {
      if (quantity >= teamThreshold && !teamModalShown && modal) {
        modal.classList.add('active');
        teamModalShown = true;
      }
    }

    // Modal controls
    var closeModalBtns = section.querySelectorAll('[data-close-modal]');
    var continueBtn = section.querySelector('[data-continue-individual]');

    closeModalBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (modal) modal.classList.remove('active');
      });
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (modal) modal.classList.remove('active');
      });
    }

    // Variant picker
    var variantOptions = section.querySelectorAll(P + '__variant-option');
    var variantInput = section.querySelector('.product-variant-id');
    var optionGroups = Array.from(section.querySelectorAll(P + '__variant-group'));

    variantOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        var group = this.closest(P + '__variant-group');
        group.querySelectorAll(P + '__variant-option').forEach(function (o) {
          o.classList.remove('selected');
        });
        this.classList.add('selected');

        var clickedGroupIdx = optionGroups.indexOf(group);

        // Cascade: for each group AFTER the clicked one, check if the
        // current selection is still valid. If not, auto-select the first valid value.
        for (var i = clickedGroupIdx + 1; i < optionGroups.length; i++) {
          var currentSelected = getSelectedOptions();
          var buttons = optionGroups[i].querySelectorAll(P + '__variant-option');
          var currentBtn = optionGroups[i].querySelector(P + '__variant-option.selected');
          var currentValue = currentBtn ? currentBtn.dataset.value : null;

          var idx = i;
          var stillValid = currentValue && productData.some(function (variant) {
            return currentSelected.every(function (opt, j) {
              if (j > idx || opt === null) return true;
              return variant['option' + (j + 1)] === opt;
            });
          });

          if (!stillValid) {
            buttons.forEach(function (b) { b.classList.remove('selected'); });
            for (var b = 0; b < buttons.length; b++) {
              var btn = buttons[b];
              var testOptions = currentSelected.slice();
              testOptions[idx] = btn.dataset.value;
              var hasMatch = productData.some(function (variant) {
                return testOptions.every(function (opt, j) {
                  if (j > idx || opt === null) return true;
                  return variant['option' + (j + 1)] === opt;
                });
              });
              if (hasMatch) {
                btn.classList.add('selected');
                break;
              }
            }
          }
        }

        syncAria();
        updateAvailability();
        updateVariant();
      });
    });

    // Variant prices in the product JSON are in the visitor's (presentment)
    // currency, so format with Shopify's active currency, not a fixed '$'.
    function formatMoney(cents) {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    // Keep ARIA radio state in sync with the .selected class (plug picker).
    function syncAria() {
      variantOptions.forEach(function (btn) {
        if (btn.hasAttribute('aria-checked')) {
          btn.setAttribute('aria-checked', btn.classList.contains('selected') ? 'true' : 'false');
        }
      });
    }

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var btn = group.querySelector(P + '__variant-option.selected');
        selected.push(btn ? btn.dataset.value : null);
      });
      return selected;
    }

    function updateAvailability() {
      var selectedOptions = getSelectedOptions();

      // For each option group, mark values as unavailable if they can't
      // produce a valid variant given the selections in all other groups
      optionGroups.forEach(function (group, groupIdx) {
        var buttons = group.querySelectorAll(P + '__variant-option');

        buttons.forEach(function (btn) {
          var testOptions = selectedOptions.slice();
          testOptions[groupIdx] = btn.dataset.value;

          var hasMatch = productData.some(function (variant) {
            return testOptions.every(function (opt, idx) {
              if (opt === null) return true;
              return variant['option' + (idx + 1)] === opt;
            });
          });

          btn.classList.toggle('unavailable', !hasMatch);
        });
      });
    }

    function updateVariant(skipPrice) {
      var selectedOptions = getSelectedOptions();

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (opt, idx) {
          if (opt === null) return true;
          return variant['option' + (idx + 1)] === opt;
        });
      });

      var addBtn = section.querySelector(P + '__add-btn');
      var availabilityEl = section.querySelector(P + '__availability');

      if (matchingVariant && variantInput) {
        variantInput.value = matchingVariant.id;

        // Update price display. Skipped on the initial market-default sync so
        // the price rendered by Liquid (Shopify's own money format) is kept.
        if (!skipPrice) {
          var priceEl = section.querySelector(P + '__price');
          if (priceEl) {
            priceEl.textContent = formatMoney(matchingVariant.price);
          }

          // Update compare-at-price display
          var priceWrapper = section.querySelector('.' + priceWrapperClass);
          var compareEl = section.querySelector(P + '__price--compare');
          if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
            if (!compareEl) {
              compareEl = document.createElement('span');
              compareEl.className = prefix + '__price--compare';
              priceWrapper.insertBefore(compareEl, priceEl.nextSibling);
            }
            compareEl.textContent = formatMoney(matchingVariant.compare_at_price);
          } else if (compareEl) {
            compareEl.remove();
          }
        }

        // Update Add to Cart button and availability based on stock
        if (addBtn) {
          var svgMarkup = (addBtn.querySelector('svg') && addBtn.querySelector('svg').outerHTML) || '';
          if (matchingVariant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = svgMarkup + ' ' + addToCartText;
          } else {
            addBtn.disabled = true;
            addBtn.innerHTML = svgMarkup + ' ' + soldOutText;
          }
        }

        // Update availability message
        if (availabilityEl) {
          availabilityEl.style.display = matchingVariant.available ? '' : 'none';
        }

        // Update URL with variant ID
        var url = new URL(window.location);
        url.searchParams.set('variant', matchingVariant.id);
        window.history.replaceState({}, '', url);
      } else if (addBtn) {
        addBtn.disabled = true;
        var svg = (addBtn.querySelector('svg') && addBtn.querySelector('svg').outerHTML) || '';
        addBtn.innerHTML = svg + ' ' + unavailableText;
      }
    }

    // Run on page load to set initial availability states, then sync the
    // hidden variant id to the pre-selected options (e.g. the market-default
    // plug type). Price is left untouched so its localized value is preserved.
    updateAvailability();
    if (optionGroups.length) {
      updateVariant(true);
    }
  }

  return { init: init };
})();

// Initialize every product section that rendered a JSON config block
// (<script type="application/json" data-xb-product-config>, see main-product-v2.liquid).
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('script[data-xb-product-config]').forEach(function (el) {
    try {
      window.XBProductCustom.init(JSON.parse(el.textContent));
    } catch (e) {
      console.error('XBProductCustom: invalid product config', e);
    }
  });
});
